import {
	useMutation,
	UseMutationResult,
	useQuery,
	UseQueryResult,
} from '@tanstack/react-query'
import { AxiosResponse } from 'axios'

import { IntegrateRequestDTO } from '@core/api/dtos/request/integration/integrate'
import { Integration } from '@core/api/entities/integration'
import { IntegrationMapper } from '@core/api/mappers/integrationMapper'
import integrationService from '@core/api/services/integrationService'

import { DEFAULT_PARAMS } from './common'

/**
 * Get all integrations
 */
export const useIntegrations = ({
	filters,
	config,
	options,
}: {
	filters?: any
	config?: any
	options?: any
} = DEFAULT_PARAMS): UseQueryResult<Integration[], Error> => {
	const QUERY_KEY = [
		'integrations',
		{
			...filters,
			...config?.params,
		},
	]

	return useQuery({
		queryKey: QUERY_KEY,
		queryFn: () =>
			integrationService.getIntegrations(filters).then(({ data: response }) => {
				return IntegrationMapper.toEntities(response.data)
			}),
		cacheTime: 0,
		staleTime: 0,
		...options,
	})
}

/**
 * Integrate with an integration or addon
 */
export const useIntegrateWithIntegration = ({
	config,
	options,
}: any = DEFAULT_PARAMS): UseMutationResult<
	AxiosResponse,
	Error,
	IntegrateRequestDTO,
	unknown
> => {
	return useMutation<AxiosResponse, Error, IntegrateRequestDTO, unknown>({
		mutationFn: (data: IntegrateRequestDTO) =>
			integrationService.integrate(data, config),
		...options,
	})
}
